import React, { useState } from 'react';
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import WaypointCard from './WaypointCard';
import Button from 'components/Button/Button';
import Text from 'components/Text/Text';
import styles from './CreateRoute.module.scss';
import { store } from 'stores/Store';

interface ICreateRoute {
  waypoints: any[];
}

const SortableItem = ({ id, waypoint, arriveTime }: { id: number, waypoint: any, arriveTime: string }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    padding: "10px",
    marginBottom: "8px",
    backgroundColor: "#f0f0f0",
    border: "1px solid #ccc",
    cursor: "grab",
    touchAction: "none" as const,
    WebkitUserSelect: "none" as const,
    userSelect: "none" as const,
    WebkitTouchCallout: "none" as const,
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <WaypointCard waypoint={waypoint} arriveTime={arriveTime} index={id}/>
    </div>
  );
};

const CreateRoute = ({ waypoints }: ICreateRoute) => {
  const [items, setItems] = useState<any[]>(waypoints);
  const [selectedTime, setSelectedTime] = useState<string>('09:00');

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor),
    useSensor(TouchSensor)
  );

  const handleDragEnd = (event: any) => {
    const { active, over } = event;

    if (active.id !== over.id) {
      setItems((items) => {
        const oldIndex = active.id;
        const newIndex = over.id;
        return arrayMove(items, oldIndex, newIndex);
      });
    }
  };

  const OpenMapsNavigation = () => {
    // Build waypoints string for Google Maps URL
    const waypointsString = items.map(waypoint => 
      `${waypoint.lat},${waypoint.long}`
    );

    // First waypoint is origin, last is destination
    const origin = waypointsString.shift();
    const destination = waypointsString.pop();

    // Build Google Maps URL with waypoints in order
    const url = `https://www.google.com/maps/dir/?api=1&origin=${origin}&destination=${destination}${waypointsString.length ? `&waypoints=${waypointsString.join('|')}` : ''}`;

    // Open in new tab
    window.open(url, '_blank');
  }

  const optimizeRoute = () => {
    console.log("Optimizing route...");

    
    // // If no origin or destination, use first waypoint for both
    // if (items.length === 1) {
    //   const singleWaypoint = {
    //     latitude: items[0].lat,
    //     longitude: items[0].long
    //   };
    //   return setItems([items[0], items[0]]);
    // }

    // // Convert waypoints to required format
    // const waypointData = items.map(waypoint => ({
    //   latitude: waypoint.lat,
    //   longitude: waypoint.long
    // }));

    // // Call optimization API
    // fetch('/api/google_routes_optimization', {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json'
    //   },
    //   body: JSON.stringify({
    //     waypoints: waypointData,
    //     departureTime: selectedTime
    //   })
    // })
    // .then(response => response.json())
    // .then(optimizedRoute => {
    //   setItems(optimizedRoute);
    // })
    // .catch(error => {
    //   console.error('Error optimizing route:', error);
    // });
  }
  
  return (
    <>
      <div>
        <Text type='header'>Create Route</Text>
        <div style={{ marginTop: '16px', marginBottom: '16px' }}>
          <Text type='body'>Select departure time:</Text>
          <input
            type="time"
            value={selectedTime}
            onChange={(e) => setSelectedTime(e.target.value)}
            style={{
              padding: '8px',
              marginTop: '8px',
              border: '1px solid #ccc',
              borderRadius: '4px'
            }}
          />
        </div>
      </div>
      <div className={styles.dndContainer}>
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
      >
        <SortableContext items={items.map((_, index) => index)} strategy={verticalListSortingStrategy}>
          {items.map((waypoint, index) => (
            <SortableItem arriveTime={waypoint.arriveTime} key={index} id={index} waypoint={waypoint} />
          ))}
        </SortableContext>
      </DndContext>
      </div>
      <div className={styles.buttonsWrapper}>
        <Button onClick={optimizeRoute}>Optimize Route</Button>
        <Button onClick={OpenMapsNavigation}>Navigate</Button>
      </div>
    </>
  );
};

export default CreateRoute;
